import { cn } from "@/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" className={cn("size-10", className)}>
      <defs>
        <linearGradient id="better-logo" x1="7" y1="5" x2="41" y2="43" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--logo-highlight)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
      </defs>
      <path d="M24 2.5 42.6 13v22L24 45.5 5.4 35V13L24 2.5Z" fill="url(#better-logo)" />
      <path d="M30.7 15.7a12 12 0 1 0 0 16.6" fill="none" stroke="var(--primary-foreground)" strokeWidth="4.2" strokeLinecap="round" />
      <path d="M26.4 24h12m-4-4 4 4-4 4" fill="none" stroke="var(--primary-foreground)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}